import {
  Enum_Componentwebelementsschedulesearchsidebarfilters_Timezone as TimezoneSelectType,
  Maybe,
} from '@ts/operations'
import { isEqual } from 'lodash'
import React from 'react'
import { Configure, connectHits } from 'react-instantsearch-dom'

import AlgoliaSearch, { AlgoliaSearchProps } from '../algolia/AlgoliaSearch'
import DynamicFilters, { Refinement } from '../search/DynamicFilters'
import SidebarFiltersLayout from '../search/SidebarFiltersLayout'
import DateRefinementNavBar from '../search/widgets/DateRefinementNavBar'
import Pagination from '../search/widgets/Pagination'
import TimezoneProvider from '../timezone/TimezoneProvider'
import LiveNowProvider from './LiveNowProvider'
import Hits from './ScheduleHits'

const ScheduleHits = connectHits(Hits)

export type ScheduleSearchProps = {
  apiKey: string
  appId?: string
  hitsPerPage?: number
  indexName: string
  refinements?: Refinement[]
  timezone?: Maybe<TimezoneSelectType>
} & Partial<AlgoliaSearchProps>

const ScheduleSearch = ({
  appId,
  apiKey,
  indexName,
  refinements = [],
  hitsPerPage = 20,
  timezone,
  ...searchProps
}: ScheduleSearchProps) => {
  return (
    <AlgoliaSearch apiKey={apiKey} appId={appId} indexName={indexName} {...searchProps}>
      <LiveNowProvider>
        <TimezoneProvider defaultActiveTimezone={timezone as string}>
          <SidebarFiltersLayout
            useTimezone
            filters={<DynamicFilters refinements={refinements} />}
            topBar={<DateRefinementNavBar />}
          >
            <Configure hitsPerPage={hitsPerPage} />
            <ScheduleHits />
            <Pagination />
          </SidebarFiltersLayout>
        </TimezoneProvider>
      </LiveNowProvider>
    </AlgoliaSearch>
  )
}

export default React.memo(ScheduleSearch, isEqual)
